/**
 * Extracts product identifiers needed for intent resolution from product data.
 *
 * @param {Object} product - The product object containing identifiers
 * @returns {Object} An object containing omsId and sku for intent resolution
 * @returns {string} returns.omsId - The OMS item ID from product identifiers
 * @returns {string} returns.sku - The SKU (storeSkuNumber, omsThdSku, or specialOrderSku)
 */
export const extractProductIdentifiersForIntent = (product) => {
  if (!product?.identifiers) {
    return { omsId: null, sku: null };
  }

  const { identifiers } = product;
  const omsId = identifiers.itemId;
  const sku = identifiers.storeSkuNumber || identifiers.omsThdSku || identifiers.specialOrderSku;

  return { omsId, sku };
};
